'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import AdWordsCampaignEntityActions from 'AdsUI/actions/AdWordsCampaignEntityActions';
import ConfirmDangerModal from 'AdsUI/components/ConfirmDangerModal';
import ScopeWrapper from 'AdsUI/components/ScopeWrapper';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import { EntityTypes, Networks } from 'AdsUI/lib/Constants';

class AdWordsRemoveCampaign extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal(e) {
    e.stopPropagation();
    this.setState(({
      modalOpen
    }) => ({
      modalOpen: !modalOpen
    }));
  }

  onRemoveCampaignConfirm() {
    this.props.removeCampaign(this.props.entity.accountId, this.props.entity.id);
    usageTracker.track('modifyCampaign', {
      action: 'Used add-on AdWords functionality to delete',
      entityType: EntityTypes.CAMPAIGN,
      network: Networks.ADWORDS
    });
    this.props.history.push('/');
  }

  render() {
    const {
      modalOpen
    } = this.state;
    return /*#__PURE__*/_jsx(ScopeWrapper, {
      tooltipKey: "removeCampaign",
      children: /*#__PURE__*/_jsxs(UIButton, {
        use: "tertiary-light",
        onClick: this.toggleModal,
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaigns.remove"
        }), modalOpen && /*#__PURE__*/_jsx(ConfirmDangerModal, {
          modalHeader: I18n.text('campaigns.adwords.confirmRemoveCampaignTitle'),
          modalDescription: I18n.text('campaigns.adwords.adCampaignRemoveDescription'),
          confirmButtonText: I18n.text('campaigns.adwords.confirmRemoveButtonText'),
          onConfirmButtonClick: this.onRemoveCampaignConfirm.bind(this),
          onCancelButtonClick: this.toggleModal
        })]
      })
    });
  }

}

export default withRouter(connect(null, {
  removeCampaign: AdWordsCampaignEntityActions.removeCampaign
})(AdWordsRemoveCampaign));